/**
 * Filter function.
 *
 * @since 3.5.7
 * */
export default function () {
    var _a = wp.data, subscribe = _a.subscribe, select = _a.select;
    // Subscribe to @wordpress/data store event.
    var unsubscribe = subscribe(function () {
        // Get the store.
        var store = select('wc/store/cart');
        var cartData = store.getCartData();
        var acfwp_block = cartData.extensions.acfwp_block;
        var isApplyingCoupon = store.isApplyingCoupon();
        // Check if the current event is applying coupon.
        if (isApplyingCoupon) {
            var couponBeingApplied_1 = store.getCouponBeingApplied(); // This will get coupon code.
            // Hide error notice if a coupon that trying to applied has force_apply option.
            var force_apply = acfwp_block.coupons.find(function (item) { return item.code === couponBeingApplied_1 && item.force_apply; });
            if (force_apply) {
                jQuery('.wc-block-components-notices').hide();
            }
        }
    });
}
